/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CashbackPoolResponse
 */
export interface CashbackPoolResponse {
  /**
   *
   * @type {number}
   * @memberof CashbackPoolResponse
   */
  distributed?: number
  /**
   *
   * @type {number}
   * @memberof CashbackPoolResponse
   */
  total?: number
}

export function CashbackPoolResponseFromJSON(json: any): CashbackPoolResponse {
  return CashbackPoolResponseFromJSONTyped(json, false)
}

export function CashbackPoolResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CashbackPoolResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    distributed: !exists(json, 'distributed') ? undefined : json['distributed'],
    total: !exists(json, 'total') ? undefined : json['total'],
  }
}

export function CashbackPoolResponseToJSON(value?: CashbackPoolResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    distributed: value.distributed,
    total: value.total,
  }
}
